/** Diffusion « messages lus » — même onglet (CustomEvent) et autres onglets (BroadcastChannel). */
const EVT = "ledesk:messages-read";
const CH = "ledesk-messages";
let channel = null;

function chan() {
  if (channel || typeof BroadcastChannel === "undefined") return channel;
  channel = new BroadcastChannel(CH);
  channel.onmessage = () => window.dispatchEvent(new Event(EVT));
  return channel;
}

export function notifyMessagesRead() {
  window.dispatchEvent(new Event(EVT));
  try { chan()?.postMessage({ type: "read" }); } catch { /* ignore */ }
}

export function onMessagesRead(cb) {
  chan();
  window.addEventListener(EVT, cb);
  return () => window.removeEventListener(EVT, cb);
}
